export const msConfig = {
    "ms-utenti":"",
    "ms-ordini":"",
    "ms-svincoli":"",
    "ms-documenti":"",
    "ms-fornitori":"",
    "ms-notifiche":"",
    "ms-non-conformita":"",
    "ms-collaudi":""
};
